// 最快吃瓜 · 娱乐资讯门户 mock 数据

export interface Post {
  id: number;
  cat: string;
  catName: string;
  title: string;
  summary: string;
  minutes: number;
  views: string;
  badge: string;
  badgeTone: 'primary' | 'accent' | 'secondary';
  image: string;
}

export const categories = [
  { key: 'all', name: '全部热闻' },
  { key: 'star', name: '明星动态' },
  { key: 'film', name: '影视现场' },
  { key: 'variety', name: '综艺娱乐' },
  { key: 'music', name: '音乐乐坛' },
  { key: 'fashion', name: '时尚红毯' },
];

export const posts: Post[] = [
  {
    id: 1, cat: 'star', catName: '明星动态',
    title: '林予安新剧《潮汐之上》杀青后首度露面，机场生图状态拉满',
    summary: '杀青刚一周，林予安就被拍到现身机场。素颜口罩、宽松针织开衫，全程低调随性，但精神状态被网友大赞在线。知情人士透露她正在为新角色做体能储备。',
    minutes: 6, views: '12.4w', badge: '现场', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20young%20actress%20in%20beige%20oversized%20cardigan%20and%20mask%20walking%20through%20bright%20modern%20airport%20terminal%20at%20golden%20hour%2C%20candid%20editorial%20paparazzi%20photography%2C%20soft%20warm%20natural%20light%2C%20shallow%20depth%20of%20field%2C%20clean%20minimal%20background&width=900&height=600&seq=chigua-p1&orientation=landscape',
  },
  {
    id: 2, cat: 'star', catName: '明星动态',
    title: '网传某顶流工作室物料提前流出，粉丝团火速开启吃瓜模式',
    summary: '一张标注"官方物料待发"的花絮截图在粉丝圈疯传，评论区有人猜宣发节点、有人扒同框图，讨论度十分钟破万。截至目前工作室暂无回应。',
    minutes: 11, views: '30.2w', badge: '独家', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=mysterious%20celebrity%20gossip%20file%20folder%20with%20paper%20prints%20and%20camera%20on%20desk%2C%20dramatic%20side%20lighting%2C%20vivid%20red%20and%20dark%20tones%2C%20editorial%20concept%20photography%2C%20moody%20atmosphere%2C%20high%20detail&width=900&height=600&seq=chigua-p2&orientation=landscape',
  },
  {
    id: 3, cat: 'star', catName: '明星动态',
    title: '顾言泽深夜被拍与《晚风信笺》主创聚餐，席间聊戏聊得投入',
    summary: '狗仔镜头里顾言泽与编剧、导演围坐一桌，一边涮火锅一边比划讨论剧本，气氛相当热络。片方工作人员回应"只是普通主创局"，但粉丝已经开始期待角色官宣。',
    minutes: 23, views: '9.1w', badge: '实锤', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=actors%20having%20late%20night%20dinner%20discussion%20at%20warm%20hot%20pot%20restaurant%2C%20steam%20rising%2C%20dim%20amber%20lantern%20lighting%2C%20candid%20behind%20the%20scenes%20editorial%20photo%2C%20cinematic%20warm%20tone%2C%20cozy%20atmosphere&width=900&height=600&seq=chigua-p3&orientation=landscape',
  },
  {
    id: 4, cat: 'star', catName: '明星动态',
    title: '温以宁时隔三年再登时尚封面，首谈"被误解的那几年"',
    summary: '温以宁这次接受专访时罕见回应了过往舆论，语气平静却坚定。编辑评价她"不再是等待答案的人"，一组大片拍出她从锋芒到沉静的转变。',
    minutes: 48, views: '18.7w', badge: '专访', badgeTone: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20actress%20editorial%20magazine%20cover%20portrait%20in%20styled%20studio%2C%20confident%20calm%20expression%2C%20dramatic%20studio%20lighting%20with%20warm%20and%20cool%20balance%2C%20fashion%20editorial%20photography%2C%20clean%20backdrop%2C%20high%20fashion%20look&width=900&height=600&seq=chigua-p4&orientation=landscape',
  },
  {
    id: 5, cat: 'film', catName: '影视现场',
    title: '《晚风信笺》新路透释出，导演透露有一场催泪重头戏',
    summary: '最新路透里男女主撑着伞并肩走过老城区巷弄，氛围感拉满。导演在探班群聊里透露全片最催泪的重头戏就在这组镜头之后，观众记得备好纸巾。',
    minutes: 35, views: '15.3w', badge: '现场', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=romantic%20drama%20film%20set%20of%20two%20people%20sharing%20an%20umbrella%20walking%20in%20old%20town%20lane%20under%20soft%20rain%2C%20cinematic%20moody%20lighting%2C%20warm%20teal%20grade%2C%20film%20production%20photography%2C%20atmospheric%20and%20emotional&width=900&height=600&seq=chigua-p5&orientation=landscape',
  },
  {
    id: 6, cat: 'film', catName: '影视现场',
    title: '悬疑剧《迷雾西岸》开播即引热议，观众评价两极却集体上头',
    summary: '节奏快、反转密集，也有人嫌叙事太跳跃。但无论站哪一队，大家都在追更——"看完根本停不下来"。第二案谜底或许藏在前三集镜头里。',
    minutes: 72, views: '42.6w', badge: '热度', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=noir%20suspense%20crime%20drama%20scene%2C%20detective%20silhouette%20near%20rainy%20harbor%20at%20night%2C%20mysterious%20fog%2C%20teal%20and%20deep%20navy%20cinematic%20grade%2C%20film%20stills%20photography%2C%20tense%20atmosphere%2C%20high%20contrast&width=900&height=600&seq=chigua-p6&orientation=landscape',
  },
  {
    id: 7, cat: 'film', catName: '影视现场',
    title: '年代剧《岁岁长青》正式杀青，服化道细节被考古式细扒',
    summary: '从旗袍针脚到老式收音机，剧组在细节上下的功夫被观众一条条截图出来夸。片方晒出杀青大合照，主演手写寄语更让剧粉集体破防。',
    minutes: 95, views: '8.9w', badge: '杀青', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=period%20era%20television%20drama%20costume%20and%20vintage%20props%2C%20elegant%20cheongsam%20hanging%20with%20old%20radio%20and%20teacup%20on%20wooden%20table%2C%20warm%20retro%20color%20palette%2C%20cinematic%20set%20photography%2C%20nostalgic%20mood&width=900&height=600&seq=chigua-p7&orientation=landscape',
  },
  {
    id: 8, cat: 'variety', catName: '综艺娱乐',
    title: '《心动周末》新一季阵容官宣，网友开年就忙着嗑糖组队',
    summary: '官方一出手就是一张全员互动海报。老粉直呼"节目组你是懂流量的"，新阵容首次同框的花絮十分钟突破二十万播放，弹幕全是上头尖叫。',
    minutes: 18, views: '26.1w', badge: '官宣', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=colorful%20variety%20show%20studio%20with%20cheerful%20celebrity%20cast%20seated%20in%20bright%20colorful%20set%20with%20soft%20bubble%20shapes%2C%20fun%20youthful%20energy%2C%20broadcast%20television%20photography%2C%20vibrant%20yet%20soft%20tone&width=900&height=600&seq=chigua-p8&orientation=landscape',
  },
  {
    id: 9, cat: 'variety', catName: '综艺娱乐',
    title: '《声浪计划》高能舞台直拍流出，现场观众反应炸了',
    summary: '一段歌手即兴高音的直拍在社交平台刷屏，前排观众的表情包被做成各种二创。节目组随后释出高清版，冲上实时热度榜前三。',
    minutes: 40, views: '38.9w', badge: '现场', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=singer%20performing%20high%20note%20on%20stage%20with%20powerful%20beam%20lights%20and%20crowd%20hands%20up%2C%20concert%20photography%2C%20dynamic%20red%20and%20gold%20stage%20lighting%2C%20electric%20atmosphere%2C%20motion%20and%20energy&width=900&height=600&seq=chigua-p9&orientation=landscape',
  },
  {
    id: 10, cat: 'variety', catName: '综艺娱乐',
    title: '真人秀《幕后主角》成为口碑黑马，把镜头对准了幕后的人',
    summary: '不贩卖焦虑、不制造冲突，节目踏踏实实记录化妆师、剪辑师、灯光师的日常，反而收获大量真诚好评，被赞"综艺里的清流"。',
    minutes: 120, views: '14.5w', badge: '黑马', badgeTone: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20documentary%20of%20film%20crew%20working%20with%20camera%20lighting%20equipment%20on%20dark%20set%2C%20candid%20observational%20cinematography%2C%20muted%20professional%20tones%2C%20authentic%20atmosphere&width=900&height=600&seq=chigua-p10&orientation=landscape',
  },
  {
    id: 11, cat: 'music', catName: '音乐乐坛',
    title: '许南乔新专辑先行曲上线一小时，收听量直接刷新纪录',
    summary: '零宣传直接空降，靠口碑一路逆袭。主打歌里那句写给自己低潮期的歌词被反复摘抄，乐评人形容"是一次漂亮的自我和解"。',
    minutes: 8, views: '22.8w', badge: '独家', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=musician%20in%20modern%20recording%20studio%20holding%20headphones%20near%20large%20window%20with%20soft%20sunlight%2C%20moody%20blue%20hour%20and%20warm%20lamp%20mix%2C%20editorial%20music%20photography%2C%20introspective%20calm%20atmosphere&width=900&height=600&seq=chigua-p11&orientation=landscape',
  },
  {
    id: 12, cat: 'music', catName: '音乐乐坛',
    title: '姜予洲巡回演唱会门票开售秒空，全网跪求加场',
    summary: '开票三分钟即告售罄，话题被刷上热搜。主办方连夜开会研究加场方案，客服电话被"求场次"打到爆，黄牛价已翻了数倍。',
    minutes: 33, views: '51.3w', badge: '爆点', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=huge%20concert%20arena%20packed%20with%20crowd%20and%20glowing%20light%20sticks%20during%20live%20show%2C%20dramatic%20spotlights%20creating%20light%20rays%2C%20wide%20angle%20concert%20photography%2C%20electrifying%20vibrant%20scene&width=900&height=600&seq=chigua-p12&orientation=landscape',
  },
  {
    id: 13, cat: 'music', catName: '音乐乐坛',
    title: '独立乐队全国巡演城市官宣，亲民票价被乐迷点赞',
    summary: '从一线城市到二线小城一口气排满二十站，票价却被乐迷夸"良心"。主唱说"想让更多人到现场听真乐器"，首站预售情况相当火热。',
    minutes: 66, views: '6.2w', badge: '官宣', badgeTone: 'secondary',
    image: 'https://readdy.ai/api/search-image?query=indie%20band%20performing%20on%20small%20intimate%20club%20stage%20with%20warm%20string%20lights%20and%20analog%20amplifiers%2C%20cozy%20retro%20vibe%2C%20editorial%20live%20music%20photography%2C%20authentic%20energy&width=900&height=600&seq=chigua-p13&orientation=landscape',
  },
  {
    id: 14, cat: 'fashion', catName: '时尚红毯',
    title: '白予棠米兰看秀生图冲上热搜，一身造型被夸"封神"',
    summary: '零修图的生图里状态能打，造型师更把东方剪裁做进了时装周语境。外网时尚博主集体转发，评价"高级且从容"。',
    minutes: 21, views: '19.4w', badge: '生图', badgeTone: 'primary',
    image: 'https://readdy.ai/api/search-image?query=fashion%20week%20front%20row%20attendee%20in%20tailored%20modern%20outfit%20seated%20at%20runway%20show%2C%20elegant%20minimal%20backdrop%2C%20clean%20fashion%20editorial%20photography%2C%20sophisticated%20neutral%20palette%20with%20subtle%20warmth&width=900&height=600&seq=chigua-p14&orientation=landscape',
  },
  {
    id: 15, cat: 'fashion', catName: '时尚红毯',
    title: '沈知夏全新大片曝光，一袭复古红裙演绎东方美学',
    summary: '整组大片以朱红与水墨为基底，裙摆的褶皱像泼开的墨。摄影师形容这是"东方意象与当下审美的正面相遇"，成片意境被赞高级。',
    minutes: 57, views: '11.6w', badge: '大片', badgeTone: 'accent',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20model%20in%20flowing%20vintage%20red%20gown%20with%20ink%20wash%20art%20backdrop%2C%20elegant%20east%20asian%20aesthetic%2C%20dramatic%20single%20light%2C%20fashion%20editorial%20photography%2C%20rich%20crimson%20and%20black%20palette%2C%20artistic&width=900&height=600&seq=chigua-p15&orientation=landscape',
  },
];

export const ticker: string[] = [
  '「今晚吃什么瓜」《迷雾西岸》今晚加更，主创空降弹幕陪聊',
  '林予安杀青后首度露面状态获赞，机场生图登上热门',
  '姜予洲演唱会门票秒空，主办方透露正在协商加场',
  '白予棠米兰生图出圈，造型师回应"只是想讲好东方故事"',
  '温以宁专访金句刷屏：不再等待答案，我自己就是答案',
  '《声浪计划》高能直拍上线，实时播放量持续攀升',
];

export const rankings: { id: number; title: string; heat: string; trend: 'up' | 'down' | 'flat' }[] = [
  { id: 1, title: '姜予洲演唱会门票三分钟售罄，加场方案研究中', heat: '513w', trend: 'up' },
  { id: 2, title: '《迷雾西岸》开播口碑两极，观众却集体上头追更', heat: '426w', trend: 'up' },
  { id: 3, title: '许南乔新专辑先行曲一小时收听破纪录', heat: '228w', trend: 'up' },
  { id: 4, title: '沈知夏复古红裙大片刷屏，东方美学引热议', heat: '194w', trend: 'up' },
  { id: 5, title: '林予安《潮汐之上》杀青后首露面，状态拉满', heat: '187w', trend: 'flat' },
  { id: 6, title: '《心动周末》新阵容官宣，网友嗑糖停不下来', heat: '158w', trend: 'down' },
  { id: 7, title: '温以宁时隔三年再登封面，回应过往争议', heat: '143w', trend: 'down' },
  { id: 8, title: '白予棠米兰看秀生图冲上热搜，造型获赞封神', heat: '129w', trend: 'up' },
  { id: 9, title: '顾言泽被拍深夜与《晚风信笺》主创聚餐', heat: '91w', trend: 'down' },
  { id: 10, title: '真人秀《幕后主角》成口碑黑马，被赞综艺清流', heat: '62w', trend: 'flat' },
];

export const highlights: { title: string; num: string }[] = [
  { title: '全网热点滚动更新', num: '24h' },
  { title: '日均吃瓜资讯生产', num: '300+' },
  { title: '粉丝站内活跃讨论', num: '80w+' },
  { title: '独家首发线索核实', num: '98%' },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: '你们的消息来源可靠吗？',
    a: '最快吃瓜坚持"来源可溯、事实优先"。每条热点都经过多渠道交叉核实：优先标注首发来源与时间，涉及争议信息会在标题明确标为"爆料"或"传闻"，实锤消息会附上可信佐证，避免带节奏和误导。',
  },
  {
    q: '"独家"和"爆料"有什么区别？',
    a: '"独家"指我们首发或独家拿到的信源内容；"爆料"多为线人或网友提供的线索，尚待多方证实。我们会在内容里清楚说明状态，后续有新进展会在"实时速递"持续跟进更新。',
  },
  {
    q: '为什么同一话题热度一直在变？',
    a: '热榜和热度值会综合站内阅读、互动和全网声量实时计算并滚动更新，随真实热度升降。所以你会看到同一话题短时间内排序变化，这正是我们"秒级更新"的体现。',
  },
  {
    q: '我吃到"过时瓜"怎么办？',
    a: '每条内容都标注了相对时间与状态标签（现场/实锤/官方/传闻等）。如果你想追最新的，直接看首屏"实时速递"和置顶滚动快讯，确保永远快人一步。',
  },
  {
    q: '发现内容有误或想反馈信息，如何联系？',
    a: '欢迎通过文末邮箱与我们取得联系。收到核实线索后，我们会在第一时间复查并更正，确保平台的每一条推送都经得起推敲。',
  },
];